import { TooltipProvider } from '@/components/ui/tooltip';
import { TanStackQueryProvider } from '@/pages/_providers/tanstack-query-provider';
import { Outlet } from 'react-router-dom';
import { Toaster } from 'sonner';

const Root = () => {
  return (
    <TooltipProvider>
      <TanStackQueryProvider>
        <Outlet />
        <Toaster />
      </TanStackQueryProvider>
    </TooltipProvider>
  );
};

export default Root;
